module.exports = __webpack_public_path__ + "static/img/h-bio.b015438.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/mobile/home/h-bio.jpg
// module id = YDIU
// module chunks = 1